import React from "react";
import {useTranslation} from 'react-i18next';
import parse from "html-react-parser";
// import resumeFile from "../documents/resume.pdf";

const AboutUs = ({classicHeader, darkTheme}) => {
    const {t} = useTranslation();
    return (
        <section id="about" className={"section " + (darkTheme ? "bg-dark-1" : "")}>
            <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
                {/* Heading */}
                <div className="position-relative d-flex text-center mb-5">
                    <h2
                        className={
                            "text-24  text-uppercase fw-600 w-100 mb-0 " +
                            (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
                        }
                    >
                        {t('about.title1')}
                    </h2>
                    <p
                        className={
                            "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
                            (darkTheme ? "text-white" : "text-dark")
                        }
                    >
                        {t('about.title2')}
                        <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto"/>
                    </p>
                </div>
                {/* Heading end*/}
                <div className="row gy-5">
                    {/* About me content start */}
                    <div className="col-lg-7 col-xl-8 text-center text-lg-start">
                        <h2
                            className={
                                "text-7 fw-600 mb-3 " + (darkTheme ? "text-white" : "")
                            }
                        >
                            {parse(t('about.subtitle'))}
                        </h2>
                        <p className={darkTheme ? "text-white-50" : ""}>
                            {t('about.text1')}
                        </p>
                        <p className={darkTheme ? "text-white-50" : ""}>
                            {t('about.text2')}
                        </p>
                        <p className={darkTheme ? "text-white-50" : ""}>
                            {t('about.text3')}
                        </p>
                    </div>
                    {/* About me content end */}
                    {/* about me personal detials start */}
                    <div className="col-lg-5 col-xl-4">
                        <div className="ps-lg-4">
                            <ul
                                className={
                                    "list-style-2 " +
                                    (darkTheme ? "list-style-light text-light" : "")
                                }
                            >
                                <li>
                                    <span className="fw-600 me-2">{t('about.name_label')}</span>Alejandro Ballesteros
                                </li>
                                <li>
                                    <span className="fw-600 me-2">{t('about.email_label')}</span>
                                </li>
                                <li>
                                    <a href="mailto:contacto@alexballesteros.com">contacto@alexballesteros.com</a>
                                </li>
                                <li className="border-0">
                                    <span className="fw-600 me-2">{t('about.location_label')}</span>Chihuahua,
                                    México
                                </li>
                            </ul>
                            <div className="ps-lg-4" style={{marginBottom: "10px"}}>
                                <a
                                    href="https://resume.io/r/cUSPJwbWK"
                                    target="_blank"
                                    rel="noreferrer"
                                    download
                                    className="btn btn-primary rounded-pill"
                                    style={{width: "100%"}}
                                >
                                    {t('about.download_cv')}
                                </a>
                            </div>
                            <div className="ps-lg-4">
                                <a
                                    href="https://resume.io/r/mmSMeNxlk"
                                    target="_blank"
                                    rel="noreferrer"
                                    download
                                    className="btn btn-primary rounded-pill"
                                    style={{width: "100%"}}
                                >
                                    {t('about.download_resume')}
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* about me personal details end */}
                </div>
                {/* projects rewards counting start */}
                <div
                    className={
                        "brands-grid separator-border mt-5 " +
                        (darkTheme ? "separator-border-light" : "")
                    }
                >
                    <div className="row">
                        <div className="col-6 col-md-3">
                            <div className="featured-box text-center">
                                <h4
                                    className={
                                        "text-12  mb-0 " +
                                        (darkTheme ? "text-white-50" : "text-muted")
                                    }
                                >
                                    <span>12</span>+
                                </h4>
                                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                                    {t('about.total_experience_years')}
                                </p>
                            </div>
                        </div>
                        <div className="col-6 col-md-3">
                            <div className="featured-box text-center">
                                <h4
                                    className={
                                        "text-12  mb-0 " +
                                        (darkTheme ? "text-white-50" : "text-muted")
                                    }
                                >
                                    <span>10,000</span>+
                                </h4>
                                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                                    {t('about.total_development_hours')}
                                </p>
                            </div>
                        </div>
                        <div className="col-6 col-md-3">
                            <div className="featured-box text-center">
                                <h4
                                    className={
                                        "text-12  mb-0 " +
                                        (darkTheme ? "text-white-50" : "text-muted")
                                    }
                                >
                                    <span>50</span>+
                                </h4>
                                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                                    {t('about.total_projects')}
                                </p>
                            </div>
                        </div>
                        <div className="col-6 col-md-3">
                            <div className="featured-box text-center">
                                <h4
                                    className={
                                        "text-12  mb-0 " +
                                        (darkTheme ? "text-white-50" : "text-muted")
                                    }
                                >
                                    <span>30</span>+
                                </h4>
                                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                                    {t('about.total_development_tools')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* projects rewards counting end */}
            </div>
        </section>
    );
};

export default AboutUs;
